import React, { useEffect, useState, useMemo, useRef } from 'react';
import Select from 'react-select';
import axios from 'axios';
import toast from 'react-hot-toast';

const NotificationForm = () => {
  const token = localStorage.getItem('astroVani-admin-token');
  const [selectedType, setSelectedType] = useState('user');
  const [userOptionsRaw, setUserOptionsRaw] = useState([]);
  const [astroOptionsRaw, setAstroOptionsRaw] = useState([]);
  const [selectedRecipients, setSelectedRecipients] = useState([]);
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [searchInput, setSearchInput] = useState('');
  const [typeName, setTypeName] = useState('fullName');
  const [isBulk, setIsBulk] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [isBulkDataSubmitted, setIsBulkDataSubmitted] = useState(false);
  const [loadingBulk, setLoadingBulk] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [userPage, setUserPage] = useState(1);
  const [astroPage, setAstroPage] = useState(1);
  const [totalUserPages, setTotalUserPages] = useState(1);
  const [totalAstroPages, setTotalAstroPages] = useState(1);
  const [limit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [selectedScreen, setSelectedScreen] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [poojaNotificationDelayTime, setPoojaNotificationDelayTime] = useState('');
  const [isUpdatingPoojaDelayTime, setIsUpdatingPoojaDelayTime] = useState(false);
  const [loadingImage, setLoadingImage] = useState(false);
  const fileInputRef = useRef(null);

  const screenOptions = [
    { label: 'Home Page', value: 'home_page' },
    { label: 'Horoscope', value: 'horoscope_section' },
    // { label: 'Numerology', value: 'numerology_section' },
    { label: 'Kundli', value: 'kundali_section' },
    { label: 'Tarot Card', value: 'tarrot_card_section' },
    { label: 'Palm Reading', value: 'palm_reading' },
    { label: 'Matchmaking', value: 'match_making_section' },
    { label: 'Baby Kundli', value: 'baby_name_generator' },
    { label: 'Panchang', value: 'panchang' },
    { label: 'Wallet / Add Money', value: 'add_money_to_wallet_page' },
    { label: 'Marriage Astrologers', value: 'marriage_astrologer_list' },
    { label: 'Love Astrologers', value: 'love_astrologer_list' },
    { label: 'Health Astrologers', value: 'health_astrologer_list' },
    { label: 'Career Astrologers', value: 'carrier_astrologer_list' },
    { label: 'Connect Tab', value: 'connect_screen' },
    { label: 'Profile Tab', value: 'profile_page' },
  ];

  const safeLabel = (item) => {
    const label = item?.fullName || item?.name || item?.email || '';
    // const idPart = item?._id;
    const mobilePart = item?.mobileNumber ? `  ${item.mobileNumber}` : '';
    return `${label} (${mobilePart})`;

    // return `${label} (${idPart}${mobilePart})`;
  };

  const fetchUsers = async () => {


    try {
      const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/user?page=${userPage}&limit=${limit}&${typeName}=${debouncedSearch}`, {
        headers: { Authorization: token },
      });
      const data = response?.data?.data || [];
      const pagination = response?.data?.paginationDetail;
      if (pagination) setTotalUserPages(pagination.totalPages);
      const uniqueUsers = Array.from(
        new Map(
          data.map((user) => [
            user._id,
            {
              ...user,
              value: user._id,
              label: safeLabel(user),
            },
          ])
        )
      ).map(([, value]) => value);
      setUserOptionsRaw(uniqueUsers);
    } catch (error) {
      toast.error('Failed to fetch users');
    }
  };

  const fetchAstrologers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/getAstro?page=${astroPage}&limit=${limit}&${typeName}=${debouncedSearch}`, {
        headers: { Authorization: token },
      });
      const data = response?.data?.data || [];
      const pagination = response?.data?.paginationDetail;
      if (pagination) setTotalAstroPages(pagination.totalPages);
      const uniqueAstros = Array.from(
        new Map(
          data.map((astro) => [
            astro._id,
            {
              ...astro,
              value: astro._id,
              label: safeLabel(astro),
            },
          ])
        )
      ).map(([, value]) => value);
      setAstroOptionsRaw(uniqueAstros);
    } catch (error) {
      toast.error('Failed to fetch astrologers');
    }
  };

  const fetchPoojaNotificationDelayTime = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASEURL}/admin/config/poojaNotificationDelayTime`, {
        headers: { Authorization: token }
      });
      if (res.data?.success) {
        setPoojaNotificationDelayTime(res.data.data?.value || 0);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleUpdatePoojaNotificationDelayTime = async () => {
    if (!poojaNotificationDelayTime) return toast.error("Please enter a valid time");
    setIsUpdatingPoojaDelayTime(true);
    try {
      await axios.patch(`${process.env.REACT_APP_BASEURL}/admin/poojaNotificationDelayTime`, { value: Number(poojaNotificationDelayTime) }, {
        headers: { Authorization: token }
      });
      toast.success("Delay Time updated successfully");
      fetchPoojaNotificationDelayTime();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to update delay time");
    } finally {
      setIsUpdatingPoojaDelayTime(false);
    }
  };

  useEffect(() => {
    fetchPoojaNotificationDelayTime();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchInput);
      if (searchInput) {
        setUserPage(1);
        setAstroPage(1);
      }
    }, 500);
    return () => clearTimeout(handler);
  }, [searchInput]);

  useEffect(() => {
    if (selectedType === 'user' || selectedType === 'allUser') {
      fetchUsers();
    } else if (selectedType === 'astrologer' || selectedType === 'allAstrologer') {
      fetchAstrologers();
    }

    if (!selectedType?.includes('user') && !selectedType?.includes('astrologer')) {
      setSelectedRecipients([]);
    }
  }, [selectedType, userPage, astroPage, debouncedSearch]);

  const currentOptionsRaw = useMemo(() => {
    return selectedType?.includes('user') ? userOptionsRaw : astroOptionsRaw;
  }, [selectedType, userOptionsRaw, astroOptionsRaw]);

  const filteredOptions = useMemo(() => {
    return currentOptionsRaw;
  }, [currentOptionsRaw]);

  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setLoadingImage(true);
      try {
        const formData = new FormData();
        formData.append("file", file);

        const response = await fetch(`${process.env.REACT_APP_BASEURL}/admin/imageUpload`, {
          method: "POST",
          body: formData,
          headers: {
            Authorization: token,
          },
        });

        if (!response.ok) throw new Error("Failed to upload image");

        const responseData = await response.json();
        const uploadedUrl = responseData?.data?.img[0];

        if (uploadedUrl) {
          setImageUrl(uploadedUrl);
          toast.success("Image uploaded successfully!");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
        toast.error("Failed to upload image.");
      } finally {
        setLoadingImage(false);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedType || !message.trim() || !title.trim()) {
      toast.error('Please fill out title, message, and recipient type.');
      return;
    }

    let idsToSend = selectedRecipients.map((rec) => rec.value);

    const payload = {
      msgFor: selectedType,
      title,
      message,
      notificationType: selectedScreen?.value || '',
      ...(imageUrl && { imageUrl }),
    };

    if (selectedType !== 'allUser' && selectedType !== 'allAstrologer') {
      payload.ids = idsToSend;
    }

    setLoadingSubmit(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/sendNotification`,
        payload,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success('Notification sent successfully!');
      setTitle('');
      setMessage('');
      setSelectedScreen(null);
      setSelectedRecipients([]);
      setImageUrl('');
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      console.error('Error sending notification:', err);
      toast.error('Failed to send notification.');
    } finally {
      setLoadingSubmit(false);
    }
  };

  const handleBulkSubmitData = async (e) => {
    e.preventDefault();
    if (!title.trim() || !message.trim() || !csvFile) {
      toast.error('Please provide a title, message, and a CSV file.');
      return;
    }

    const formData = new FormData();
    formData.append('title', title);
    formData.append('message', message);
    formData.append('notificationFor', selectedType);
    formData.append('file', csvFile);
    formData.append('notificationType', selectedScreen?.value || '');
    if (imageUrl) {
      formData.append('imageUrl', imageUrl);
    }

    setLoadingUpload(true);
    try {
      await axios.post(`${process.env.REACT_APP_BASEURL}/admin/bulkUploadProfileUpdateNotification`, formData, {
        headers: {
          Authorization: token,
          'Content-Type': 'multipart/form-data',
        },
      });
      toast.success('Bulk data uploaded successfully!');
      setIsBulkDataSubmitted(true);
    } catch (err) {
      console.error('Error uploading bulk data:', err);
      toast.error(err.response?.data?.message || 'Failed to upload bulk data.');
    } finally {
      setLoadingUpload(false);
    }
  };

  const handleSendBulkNotification = async (e) => {
    e.preventDefault();
    if (!title.trim() || !message.trim()) {
      toast.error('Please fill out title and message.');
      return;
    }

    setLoadingBulk(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_BASEURL}/admin/executeBulkProfileUpdateNotification`,
        {},
        {
          headers: {
            Authorization: token,
            'Content-Type': 'application/json',
          },
        }
      );
      toast.success('Bulk notifications sent successfully!');
      // Reset Form
      setIsBulk(false);
      setTitle('');
      setMessage('');
      setSelectedScreen(null);
      setCsvFile(null);
      setIsBulkDataSubmitted(false);
      setSelectedType('user');
      setSelectedRecipients([]);
      setImageUrl('');
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      console.error('Error sending bulk notification:', err);
      toast.error(err.response?.data?.message || 'Failed to send bulk notification.');
    } finally {
      setLoadingBulk(false);
    }
  };

  const handleDownloadSample = () => {
    const csvContent = "mobileNumber\n82XXXXXX12\n70XXXXXX55\n70XXXXXX22";
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "bulk_notification_sample.csv");
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="container py-3">
      <div className="card shadow-sm p-3 mb-4">
        <h5 className="fw-bold mb-3">Global AppConfig</h5>
        <div className="d-flex align-items-center gap-3 flex-wrap">
          <label className="fw-semibold mb-0">Pooja Notification Delay Time (minutes):</label>
          <input
            type="number"
            className="form-control"
            style={{ maxWidth: '200px' }}
            value={poojaNotificationDelayTime}
            onChange={(e) => setPoojaNotificationDelayTime(e.target.value)}
          />
          <button
            className="btn btn-primary"
            onClick={handleUpdatePoojaNotificationDelayTime}
            disabled={isUpdatingPoojaDelayTime}
          >
            {isUpdatingPoojaDelayTime ? 'Updating...' : 'Update Delay'}
          </button>
        </div>
      </div>

      <div className="card shadow-sm p-4">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="fw-bold mb-0">Send Notification</h4>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="bulkToggle"
              style={{ cursor: 'pointer' }}
              checked={isBulk}
              onChange={(e) => {
                setIsBulk(e.target.checked);
                setIsBulkDataSubmitted(false);
                setCsvFile(null);
              }}
            />
            <label className="form-check-label fw-bold" htmlFor="bulkToggle" style={{ cursor: 'pointer' }}>
              Bulk Users
            </label>
          </div>
        </div>

        {/* Recipient Type or CSV Upload */}
        <div className="mb-3">
          {isBulk ? (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label fw-semibold mb-0">Upload Bulk User CSV file</label>
                <button
                  type="button"
                  className="btn btn-outline-primary btn-sm"
                  onClick={handleDownloadSample}
                  style={{ fontSize: '12px' }}
                >
                  <i className="icofont-download me-1"></i> Sample CSV
                </button>
              </div>
              <input
                type="file"
                className="form-control shadow-none"
                accept=".csv"
                onChange={(e) => setCsvFile(e.target.files[0])}
              />
            </>
          ) : (
            <></>
          )}
        </div>


        <div className="mb-3">
          <label className="form-label fw-semibold">Select Recipient Type</label>
          <Select
            value={selectedType ? selectedType === "user" ? { value: 'user', label: 'User' } : { value: 'astrologer', label: 'Astrologer' } : null}
            options={[
              { value: 'user', label: 'User' },
              { value: 'astrologer', label: 'Astrologer' },
              // ...(!isBulk ? [{ value: 'allUser', label: 'All User' }, { value: 'allAstrologer', label: 'All Astrologer' }] : []),
            ]}
            onChange={(option) => setSelectedType(option.value)}
            placeholder="Choose type..."
          />
        </div>

        {/* Multi-Select for Individuals (Only if not Bulk) */}
        {!isBulk && (selectedType === 'user' || selectedType === 'astrologer') &&
          !['allUser', 'allAstrologer'].includes(selectedType) && (
            <div className="mb-3 border p-1">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <label className="form-label fw-semibold mb-0">
                  Select {selectedType === 'user' ? 'Users' : 'Astrologers'}
                </label>
              </div>
              <div className="mt-2">
                <div className="d-flex justify-content-between align-items-center w-100 gap-3">
                  <select
                    className="form-select form-control-sm"
                    style={{ width: "20%" }}
                    value={typeName}
                    onChange={(e) => setTypeName(e.target.value)}
                  >
                    <option value="fullName">Full Name</option>
                    <option value="mobileNumber">Mobile Number</option>
                  </select>

                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder={`Search ${selectedType}...`}
                    value={searchInput}
                    onChange={(e) => setSearchInput(e.target.value)}
                  />
                </div>

                <div className="d-flex justify-content-between align-items-center mt-2">
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={selectedType === 'user' ? userPage === 1 : astroPage === 1}
                    onClick={() => {
                      if (selectedType === 'user') setUserPage((p) => Math.max(1, p - 1));
                      else setAstroPage((p) => Math.max(1, p - 1));
                    }}
                  >
                    Previous
                  </button>
                  <span className="fw-semibold">Page {selectedType === 'user' ? userPage : astroPage} of {selectedType === 'user' ? totalUserPages : totalAstroPages}</span>
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    disabled={selectedType === 'user' ? userPage >= totalUserPages : astroPage >= totalAstroPages}
                    onClick={() => {
                      if (selectedType === 'user') setUserPage((p) => p + 1);
                      else setAstroPage((p) => p + 1);
                    }}
                  >
                    Next
                  </button>

                </div>
              </div>
              <Select
                isMulti
                options={filteredOptions}
                value={selectedRecipients}
                onChange={setSelectedRecipients}
                placeholder={`Search and select ${selectedType}s...`}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: '200px',
                    overflowY: 'auto',
                  }),
                }}
              />
            </div>
          )}

        {/* Notification Title */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Notification Title</label>
          <input
            type="text"
            className="form-control"
            placeholder="Enter notification title..."
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>

        {/* Notification Message */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Notification Message</label>
          <textarea
            className="form-control"
            rows="4"
            placeholder="Type your message..."
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        </div>

        {/* Notification Image */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Notification Image (Optional)</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
            disabled={loadingImage}
            ref={fileInputRef}
          />
          {loadingImage && <small className="text-muted">Uploading image...</small>}
          {imageUrl && (
            <div className="mt-2">
              <img src={imageUrl} alt="Notification Preview" style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }} />
            </div>
          )}
        </div>

        {/* Target Screen Dropdown */}
        <div className="mb-3">
          <label className="form-label fw-semibold">Target Screen</label>
          <Select
            options={screenOptions}
            value={selectedScreen}
            onChange={setSelectedScreen}
            placeholder="Select target screen..."
          // isClearable
          />
        </div>

        {/* Action Button(s) */}
        {!isBulk ? (
          <button
            className="btn w-100 fw-bold py-2 mt-2"
            onClick={handleSubmit}
            disabled={!title.trim() || !message.trim() || loadingSubmit || !selectedScreen}
            style={{ backgroundColor: (loadingSubmit || !title.trim() || !message.trim() || !selectedScreen) ? '#ccc' : '#eab34e', border: 'none', color: 'white' }}
          >
            {loadingSubmit ? 'Sending...' : 'Send Notification'}
          </button>
        ) : (
          <div className="d-flex flex-column gap-2 mt-2">
            <button
              className="btn fw-bold py-2"
              onClick={handleBulkSubmitData}
              disabled={!title.trim() || !message.trim() || !csvFile || loadingUpload || !selectedScreen || isBulkDataSubmitted}
              style={{
                backgroundColor: (!title.trim() || !message.trim() || !csvFile || loadingUpload || !selectedScreen || isBulkDataSubmitted) ? '#ccc' : '#eab34e',
                border: 'none',
                color: 'white',
              }}
            >
              {loadingUpload ? 'Uploading...' : 'Submit Notification Data for Bulk User'}
            </button>
            <button
              className="btn fw-bold py-2"
              onClick={handleSendBulkNotification}
              disabled={!isBulkDataSubmitted || loadingBulk}
              style={{
                backgroundColor: (!isBulkDataSubmitted || loadingBulk) ? '#ccc' : '#eab34e',
                border: 'none',
                color: 'white',
              }}
            >
              {loadingBulk ? 'Sending...' : 'Send Bulk Notification'}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default NotificationForm;
